const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://offersshopping.com';

export default function EstudiantesSeoJsonLd() {
  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Pack Estudiantes', item: `${SITE_URL}/estudiantes` },
    ],
  };

  const product = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'Pack Estudiante - Office + Antivirus + VPN',
    description: 'Paquete exclusivo para estudiantes: elige tu Office 365, Antivirus y VPN con 10% de descuento adicional con código de estudiante. Licencias originales con entrega inmediata.',
    url: `${SITE_URL}/estudiantes`,
    brand: { '@type': 'Brand', name: 'Digital Licence Store' },
    offers: {
      '@type': 'AggregateOffer',
      priceCurrency: 'COP',
      lowPrice: '49950',
      highPrice: '619650',
      offerCount: '18',
      availability: 'https://schema.org/InStock',
      url: `${SITE_URL}/estudiantes`,
      seller: { '@type': 'Organization', name: 'Digital Licence Store' },
    },
    audience: {
      '@type': 'EducationalAudience',
      educationalRole: 'student',
    },
  };

  const webpage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Pack Estudiante - Office + Antivirus + VPN con Descuento | Digital Licence Store',
    description: 'Arma tu pack de software para estudiantes: Office 365, Antivirus y VPN con 10% de descuento exclusivo. Licencias originales con entrega inmediata en Colombia.',
    url: `${SITE_URL}/estudiantes`,
    inLanguage: 'es-CO',
    isPartOf: { '@type': 'WebSite', name: 'Digital Licence Store', url: SITE_URL },
    breadcrumb: breadcrumb,
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(product) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpage) }} />
    </>
  );
}
